import script from "./SchemaPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaPanel.vue?vue&type=script&setup=true&lang=js"

import "./SchemaPanel.vue?vue&type=style&index=0&id=6fc1fd6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc1fd6a"]])

export default __exports__